import { gql } from '@apollo/client';

export interface EmployerConfigVariables {
  employerId: string;
}

export interface EmployerConfigResponse {
  getEmployerConfig: {
    reimbursementWindow?: ReimbursementWindow;
  };
}

interface ReimbursementWindow {
  windowBegin?: ReimbursementWindowDetails;
  windowEnd?: ReimbursementWindowDetails;
}

interface ReimbursementWindowDetails {
  days?: number;
  daysAfter?: 'term_end' | 'term_start' | string;
}

export const GET_EMPLOYER_CONFIG = gql`
  query GET_EMPLOYER_CONFIG($employerId: ID!) {
    getEmployerConfig(employerId: $employerId) {
      reimbursementWindow {
        windowBegin {
          days
          daysAfter
        }
        windowEnd {
          days
          daysAfter
        }
      }
    }
  }
`;
